export default "__VITE_ASSET__D2TXCrtn__ 500w";